import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/zhihu': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M170.5 148.1h122.7v217.6h-49.5l-42 26.4-7.7-26.4-23.4 0v-217.5zM268.3 342.1v-170.3h-72.8v170.3l11.9 0 5.1 17.5 27.9-17.5h27.9zM149.8 247.7c7.5 0 7.6 23.6 7.6 23.6h-61.7c-0.9 13.1-3.5 26.7-7.9 40.7l14.6-11.6c8.7 8.8 29.2 32.9 36.8 41.8 9.2 13.1 1.2 40 1.2 40l-54-64.9c-12.6 48.3-35.6 69.3-35.6 69.3-10.1 9-30.5 15.8-51 9.9 42.8-33.2 66.5-75.2 70.8-125.1h-65.6s3.8-23.6 15.6-23.6h52.3c0.5-6.6 1.7-62.9 1.7-73.4h-28.9c-2.6 7.9-3 8.6-5.1 14.5-11.5 21-30.9 21.6-36.8 22.2 17.5-35 27.3-69.2 30.7-78.1 8.2-21.6 32.3-21.6 32.3-21.6-5.3 14-9.6 27.5-13.1 40.7h88.5c10.5-0.3 8.6 22.3 8.6 22.3h-51.2c0 21.9-0.5 46.4-2.2 73.5h52.3zM561.9 246.1l-19.2-14.4s30.8-40 36.8-48.2c8.7-10.7 27.4 4.1 27.4 4.1s-24.2 32.9-45 58.6zM411.8 187l0 0c9 8.3 34.7 45.9 34.7 45.9l-19.5 13.7c-1.6-2.4-41.1-57.4-41.1-57.4s16.9-10.4 25.9-2.1zM640 258.4c0 0 1 23.8-8.7 23.8h-122.4v73.3c0.8 28-15.3 45.3-44.9 45.3-9.8 0-16.1-1.8-26-6.6-13-7.5-17.3-17.9-19.3-21.8 15.6 0.7 27.6 1.9 41.7 1.8 13.3 0.9 24.5-7.2 24.5-21.1v-70.9h-107.9c-22.7-0.5-25.5-22.8-25.5-22.8h133.5v-99.8c-12.8 0-31.7 0.8-56.5 2.4-26.5 0.8-35.8 2.6-49.2-0.9-8.2-2.5-14.2-10.7-15.8-19.5 67.1-1.6 232.4-18 232.4-18s20.1-5.8 23.2-4.6c12.8 6.3 0.6 33.4 0.6 33.4-17.6 0.8-46.9 2.4-87.8 4.8-10.4 0.8-18 1.2-22.8 1.2v101c0.1 0 111.3-0.9 131.1-0.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/zhihu.js
// module id = 1118
// module chunks = 0